<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="safeForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.safeMake }}</v-subheader>
              <div class="queryValue" v-for="item in filterSafeMakeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="safeMakeList"
                v-model="safeForm.safeMake"
                :label="labels.safeMake"
                item-text="label"
                item-value="value"
                data-vv-name="safeForm.safeMake"
                :data-vv-as="labels.safeMake"
                :error-messages="errors.collect('safeForm.safeMake')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md8 lg8 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.safeDim }}</v-subheader>
              <div class="queryValue">{{ safeForm.safeDim }}</div>
            </v-flex>
            <v-flex xs12 md8 lg8 v-else>
              <v-text-field
                :label="labels.safeDim"
                v-model="safeForm.safeDim"
                :error-messages="errors.collect('safeForm.safeDim')"
                data-vv-name="safeForm.safeDim"
                :data-vv-as="labels.safeDim"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.safeLock }}</v-subheader>
              <div class="queryValue" v-for="item in filterSafeLockList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="entLockTypeList"
                v-model="safeForm.safeLock"
                :label="labels.safeLock"
                item-text="label"
                item-value="value"
                data-vv-name="safeForm.safeLock"
                :data-vv-as="labels.safeLock"
                :error-messages="errors.collect('safeForm.safeLock')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md8 lg8>
              <v-checkbox
                color="primary"
                :label="labels.safeConcld"
                v-model="safeForm.safeConcld"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.lossRemarks }}</v-subheader>
              <div class="queryValue">{{ safeForm.lossRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="safeForm.lossRemarks"
                :label="labels.lossRemarks"
                :error-messages="errors.collect('safeForm.lossRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="safeForm.lossRemarks"
                :data-vv-as="labels.lossRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.remarks }}</v-subheader>
              <div class="queryValue">{{ safeForm.remarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="safeForm.remarks"
                :label="labels.remarks"
                :error-messages="errors.collect('safeForm.remarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="safeForm.remarks"
                :data-vv-as="labels.remarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { safeMakeList, entLockTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        safeMake: 'Safe Make',
        safeDim: 'Dimensions',
        safeLock: 'Type of Lock',
        safeConcld: 'Is safe concealed?',
        lossRemarks: 'Insured / Loss History and Remarks',
        remarks: 'Remarks and Recommendations'
      },
      safeForm: {
        survNo: undefined,
        verCnt: undefined,
        safeMake: undefined,
        safeDim: undefined,
        safeLock: undefined,
        safeConcld: false,
        lossRemarks: undefined,
        remarks: undefined,
        survDetType: 'safeRoom'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      safeMakeList: [],
      entLockTypeList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterSafeMakeList() {
      return this.safeMakeList.filter((list) => {
        return list.value === parseInt(this.safeForm.safeMake)
      })
    },
    filterSafeLockList() {
      return this.entLockTypeList.filter((list) => {
        return list.value === parseInt(this.safeForm.safeLock)
      })
    }
  },
  methods: {
    async doInit() {
      this.safeForm.survNo = this.riskSurveyMaster.survNo
      this.safeForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.safeForm.safeMake = parseInt(this.riskSurveyDetails.safeMake)
      this.safeForm.safeDim = this.riskSurveyDetails.safeDim
      this.safeForm.safeLock = parseInt(this.riskSurveyDetails.safeLock)
      this.safeForm.safeConcld = this.riskSurveyDetails.safeConcld
      this.safeForm.lossRemarks = this.riskSurveyDetails.lossRemarks
      this.safeForm.remarks = this.riskSurveyDetails.remarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.safeForm.safeMake = undefined
      this.safeForm.safeDim = undefined
      this.safeForm.safeLock = undefined
      this.safeForm.safeConcld = false
      this.safeForm.lossRemarks = undefined
      this.safeForm.remarks = undefined
    }
  },
  created() {
    this.safeMakeList = safeMakeList
    this.entLockTypeList = entLockTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
